module.exports = __webpack_public_path__ + "img/utility_knife.df698566.png";